import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=c0c1a6c0&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=ts&"
export * from "./PDF.vue?vue&type=script&lang=ts&"
import style0 from "./PDF.vue?vue&type=style&index=0&id=c0c1a6c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c1a6c0",
  null
  
)

export default component.exports